import React,{useState, useRef, useContext, useEffect, memo} from 'react'
import { Outlet, NavLink, Link, useLoaderData, useLocation } from "react-router-dom";
import { ThemeContext } from '../context/ThemeContext';
import { useDarkMode } from '../customhooks/ThemeHook';
import ProgressiveImage from './ProgressiveImage/FirstSlider';
import ProgressiveImageImg from './ProgressiveImage/FirstSlider';

import gsap from 'gsap'
/*import './work_4.css'*/



const WorkCine = memo( (props) => {

  //const featuredImage = 'https://discover.frankariza.com/storage/app/uploads/public/c23/4f8/aee/thumb__1300_700_0_0_crop.jpg';
  const featuredImage = '/static/trans.gif';
  const sectionPath = props.path || 'cine';

  const theme = useContext(ThemeContext);
  const [darkMode, setDarkMode] = useDarkMode(false);
  const selectedWork = useRef();
  let projectsData = useLoaderData();
  let projects = projectsData.items;

  const location = useLocation();
  const [projectsGrid,setProjectsGrid] = useState(0);

    useEffect(() => {


      if( location.pathname.split('/').length === 2 ){
        setProjectsGrid(1);
      }else{
        setProjectsGrid(0);
      }



      if (location.hash) {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }, [location]);






  function transitionEffect(e){
    gsap.to(selectedWork.current,1,{ delay:1, opacity:0,ease:'easeIn' });
  }

  useEffect((props) => {


    var debugInput = document.querySelector("input");
   function updateDebugState() {
       document.body.classList.toggle('debug-on', debugInput.checked);
   }
   debugInput.addEventListener("click", updateDebugState);
   updateDebugState();
});







  return (
    <div style={{maxWidth:1380+'px'}} className="w-full text-center items-center">

      { projectsGrid == 1 ?
        <>
          <div style={{backgroundColor: '#12283B', backgroundImage: 'url(' + featuredImage + ')',backgroundPosition:'center', backgroundSize:'cover'}} className="relative background-cover h-[40vh]">
            <h1 style={{fontSize:'300%'}} className="text-center w-full pt-[20vh] text-8xl text-white">{props.title || 'CINE'}</h1>
        </div>

        {/*   <div className="w-full text-gray-900 fadeIn pt-4">
         <h2 style={{fontSize:'2em'}} className="text-8xl font-medium text-center px-8 py-12 pb-4 text-inherit">Cinema</h2>
          </div>
          */}
          <div className=" w-full py-8 pt-18 center">
                  <div className="py-2">

                    {projects.length > 0 ? projects.map((project,index) => (
                    index < 200 ?

                    <div className="py-4 grow inline-block w-[280px] text-gray-800  mx-1 items-center justify-center text-md font-medium" key={'doc-'+ index}>

                        <NavLink className="w-full" to={'../' + sectionPath + '/' + project.slug} onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:sectionPath }}>

                        <picture id={'btn-' + index} className="link">
                        <ProgressiveImageImg
                        src={project.image_thumb.url}
                        placeholder={'/static/trans.gif'}
                        modal={theme.modal}
                        bg={'#333'}
                        imgMargin={props.imgMargin}
                        />
                        </picture>

                        {/*
                          <div className="flex flex-col p-1 space-y-1 text-left">
                            <p className="notranslate font-light text-gray-200 pb-2 pt-1 text-wrap">{project.name}</p>
                        </div>
                        */}

                      </NavLink>

                    </div>

                     : ''     ))  : ''}

                  </div>
          </div>
        </>
         :
         '' }



    <div style={{display:'none'}} className="debug">
    <label><input type="checkbox"/>Debug </label>
  </div>

  <div className="z-900">
  <Outlet/>
</div>

</div>
  )
})

export default WorkCine
